/**
 * DpiaAssessment Service Layer
 * Rule: Business logic, validation, and API orchestration
 * Rule: NO UI IN SDK
 */
import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class DpiaAssessmentService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
                pagination: response.pagination,
                uniqueValues: response.uniqueValues,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch dpia-assessment list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch dpia-assessment');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to create dpia-assessment');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to update dpia-assessment');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete dpia-assessment');
        }
    }

    async submit(id) {
        try {
            const response = await this.api.submit(id);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to submit dpia-assessment');
        }
    }

    async complete(id, data = {}) {
        try {
            const response = await this.api.complete(id, data);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to complete dpia-assessment');
        }
    }

    async createRisk(id) {
        try {
            const response = await this.api.createRisk(id);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to create risk from dpia-assessment');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
